var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//@ts-check
import coordtransform from 'coordtransform';

export default function (result, target, callback) {

    //@ts-ignore
    if (result.geotype.toUpperCase() === target) {
        return callback(null, result);
    }

    if (target === 'WGS84') {
        var _coordtransform$gcj = coordtransform.gcj02towgs84(result.longitude, result.latitude),
            lng = _coordtransform$gcj[0],
            lat = _coordtransform$gcj[1];

        return callback(null, _extends({}, result, {
            geotype: 'WGS84',
            latitude: lat,
            longitude: lng
        }));
    }

    if (target === 'GCJ02') {
        var _coordtransform$wgs = coordtransform.wgs84togcj02(result.longitude, result.latitude),
            _lng = _coordtransform$wgs[0],
            _lat = _coordtransform$wgs[1];

        return callback(null, _extends({}, result, {
            geotype: 'GCJ02',
            latitude: _lat,
            longitude: _lng
        }));
    }

    callback(null, result);
}